export type FeaturesToPersist = {
  density?: boolean;
  columns?: {
    columnVisibilityModel?: boolean;
    dimensions?: boolean;
    orderedFields?: boolean;
  };
  sorting?: boolean;
  filter?: boolean;
  pagination?: boolean;
  pinnedColumns?: boolean;
};

export const defaultFeaturesToPersist: FeaturesToPersist = {
  density: true,
  columns: {
    columnVisibilityModel: true,
    dimensions: true,
    orderedFields: true,
  },
  sorting: true,
  pagination: true,
  pinnedColumns: true,
};

export const featuresToPersistPresets: Record<string, FeaturesToPersist> = {
  default: defaultFeaturesToPersist,
  minimal: {
    columns: {
      dimensions: true,
      orderedFields: true,
    },
    sorting: true,
    pinnedColumns: true,
  },
  advanced: {
    density: true,
    columns: {
      columnVisibilityModel: true,
      dimensions: true,
      orderedFields: true,
    },
    sorting: true,
    filter: true,
    pagination: true,
    pinnedColumns: true,
  },
};

export const getFeaturesToPersist = (preset: string): FeaturesToPersist => {
  return featuresToPersistPresets[preset] || defaultFeaturesToPersist;
};
